import {FormView} from '../../src/components/_views/configurable/FormView';
import OrderForm from './OrderForm';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';

export class OrderUpdateForm extends FormView {
    protected getFormComponent() {
        return OrderForm;
    }
}

export default OrderUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(OrderUpdateForm));
